// Generated with util/create-component.js
import React, { useState, useEffect, createContext, useRef, useMemo } from 'react'
import { TabstripProps } from './Tabstrip.types'
import TabTitle from './TabTitle'
import useTabs from './useTabs'
import Button from '../Button/Button'
import merge from 'lodash/merge'

const Tabstrip: React.FC<TabstripProps> = ({
    isDiscreet = false,
    withRoute,
    withPanel,
    children,
    tabWrapper,
    invert,
    stack = false,
    style = 'default',
}) => {
    const { colors, current } = useTabs()
    const ref = useRef(null)
    const background = colors?.background ?? null
    const [isOverflow, setIsOverflow] = useState(false)
    const [internalChildren, setInternalChildren] = useState(children)
    const [tabRows, setTabRows] = useState<any>({})

    const handleSetTabRow = (id, index, row, isLeadingPos) => {
        setTabRows((prev) => {
            const newColl = merge({}, prev)
            newColl[id] = { id, row, isLeadingPos, index }
            return { ...newColl }
        })
    }

    const handleScroll = (dir) => {
        if (ref.current) {
            const currentScroll = ref.current.scrollLeft
            let nextScroll
            if (dir === 'right') {
                nextScroll = currentScroll + 100
            } else {
                nextScroll = currentScroll - 100
            }
            ref.current.scroll(nextScroll, 0)
        }
    }

    useEffect(() => {
        setTimeout(() => {
            const element = ref.current
            if (!element || stack) {
                return
            }
            const i = element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth
            setIsOverflow(i)
        }, 100)
    }, [ref.current])

    const renderChildren = useMemo(() => {
        let tabTitleContainer = {}

        if (ref.current) {
            tabTitleContainer = ref.current.getBoundingClientRect()
        }

        return React.Children.map(internalChildren, (child, i) => {
            let el = React.cloneElement(child, {
                index: i,
                tabTitleContainer,
                handleSetTabRow,
            })
            return el
        })
    }, [internalChildren, ref.current])

    useEffect(() => {
        return
        let rows = 1
        let switchPos = false
        let leadingPosIndex = 0
        let switchIndex = 0
        // let switchPos = false

        Object.keys(tabRows).forEach((r) => {
            if (tabRows[r].isLeadingPos) {
                leadingPosIndex = tabRows[r].index
            }
            if (tabRows[r].row > rows) {
                rows = tabRows[r].row
            }
        })

        Object.keys(tabRows).forEach((r) => {
            const node = tabRows[r]
            if (node.id === current) {
                if (node.row < rows) {
                    // switchPos = true
                    switchIndex = node.index
                }
            }
        })

        if (switchPos) {
            setInternalChildren((prev) => {
                const newChil = prev.slice()
                var z = newChil[leadingPosIndex]
                newChil[leadingPosIndex] = newChil[switchIndex]
                newChil[switchIndex] = z
                return [...newChil]
            })
        }
    }, [current])

    return (
        <div
            className={`r-tabstrip-container ${stack ? 'r-state-stack' : ''} style-tabs ${
                isDiscreet ? 'r-state-discreet' : ''
            } ${invert ? 'r-tab-invert' : ''} ${withPanel ? 'r-tab-panel' : ''} r-style-${style}`}
        >
            {isOverflow ? (
                <Button isDiscreet size={'sm'} icon={'chevron-left'} onClick={() => handleScroll('left')} />
            ) : null}
            <div ref={ref} style={{ background }} className='r-tab-titles-container'>
                {renderChildren}
            </div>
            {isOverflow ? (
                <Button isDiscreet size={'sm'} icon={'chevron-right'} onClick={() => handleScroll('right')} />
            ) : null}
        </div>
    )
}

export default Tabstrip
